import { render, staticRenderFns } from "./AppAccessDenied.vue?vue&type=template&id=b8f16b5c&scoped=true"
import script from "./AppAccessDenied.vue?vue&type=script&lang=js"
export * from "./AppAccessDenied.vue?vue&type=script&lang=js"
import style0 from "./AppAccessDenied.vue?vue&type=style&index=0&id=b8f16b5c&prod&style=css&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f16b5c",
  null
  
)

export default component.exports